import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";

import { Pill } from "src/base-components/Pill";
import { UserPill } from "src/cases/common/UserPill";
import { OrganizationUser } from "src/clients/taktile-api";

type AssigneePillProps = {
  assignee: OrganizationUser;
  withChevron?: boolean;
  fullWidth?: boolean;
};

export const CaseAssigneePill: React.FC<AssigneePillProps> = ({
  assignee,
  withChevron,
}) => {
  return (
    <UserPill
      postfixIcon={withChevron ? <Pill.Icon icon={faChevronDown} /> : undefined}
      user={assignee}
      fullWidth
    />
  );
};
